import { makeStyles } from 'tss-react/mui'

export const useDownloadDetailPdfButtonStyles = makeStyles()(theme => ({
  linkItem: {
    padding: theme.spacing(0, 0.5),
    minHeight: theme.spacing(2),
    border: 0,
    fontWeight: 500,
    fontSize: theme.spacing(1.75),
    lineHeight: '20px',
  },
  icon: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    fontSize: theme.spacing(2),
    padding: theme.spacing(0, 1, 0, 0),
  },
}))
